import {PrintLabelSheetActions} from "../actions/PrintLabelSheetActions";
import {printLabelSheet} from "../network/PrintLabelSheetAPI";
import {PrintLabelErrorMessages} from "../constants/PrintLabelErrorMessages";

export const PrintLabelReducer = (state, action) => {
    switch (action.type) {
        case PrintLabelSheetActions.PRINT_LABEL_SHEET:
            const  {trackingIds, dispatcher} = action.data;
            printLabelSheet(trackingIds, dispatcher);
            return {...state, isLoading: true, requestCompleted: false};
        case PrintLabelSheetActions.PRINT_LABEL_SHEET_RESPONSE:
            return {...state, isLoading: false, requestCompleted: true};
        case PrintLabelSheetActions.PRINT_LABEL_SHEET_ERROR_RESPONSE:
            return {...state, isLoading: false, requestCompleted: true,
                errorOccurred: true, errorMessage: action.msg ? action.msg : PrintLabelErrorMessages.DEFAULT};
        case PrintLabelSheetActions.RESET_REQUEST:
            return {...state, isLoading: false, requestCompleted: false,
                errorOccurred: false, errorMessage:""};
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/labelSheet/reducers/PrintLabelReducer.js